import { render, staticRenderFns } from "./online_mapping.vue?vue&type=template&id=61c945c7&scoped=true"
import script from "./online_mapping.vue?vue&type=script&lang=js"
export * from "./online_mapping.vue?vue&type=script&lang=js"
import style0 from "./online_mapping.vue?vue&type=style&index=0&id=61c945c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c945c7",
  null
  
)

export default component.exports